import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewCourse, ViewCourseDefaultValues } from 'src/app/components/course/course';
import { AuthService } from 'src/app/services/auth.service';
import { CourseService } from 'src/app/services/course.service';
import { FileService } from 'src/app/services/file.service';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-view-course-participant',
    templateUrl: './view-course-participant.component.html',
    styleUrls: ['./view-course-participant.component.scss'],
    standalone: false
})
export class ViewCourseParticipantComponent {
  course: ViewCourse = ViewCourseDefaultValues();
  id: string = '';
  coursematerial: any[] = [];
  translations: Record<string, string> = {};
  imageURL: string | undefined;
  courseStatus: string = '';
  courseTags: any[] = [];
  loggedInUserPublicId: string = '';
  isViewCourseVisible: boolean = false;
  participantClassByRole: string = '';
  llttfPage: boolean = false;
  defaultMaterialId: string = '';
  flushed: string = 'flushed';
  
  constructor(
    private courseservice: CourseService,
    private route: ActivatedRoute,
    private fileservice: FileService,
    private router: Router,
    private authservice: AuthService,
    private themeService: ParticipantThemeService,
    private translationService: TranslationService)
  { }

  ngOnInit(): void {
    this.loggedInUserPublicId = this.authservice.getUserLoginData().publicId;
    this.route.params.subscribe({
      next:(params) => {
        this.id = params['id'];
        this.getCourseDetails(this.id);
      }
    });

    this.themeService.setParticipantTheme();
    this.llttfPage = this.themeService.llttfPage;
    this.participantClassByRole = this.themeService.participantClassByRole;

    this.translationService.getTranslation().subscribe({
      next: (t) => { this.translations = t; }
    });
  }

  materialRetiredPopupHtml(material: { materialRetirementAccessUntil?: string }): string {
    const until = material.materialRetirementAccessUntil ?? '';
    const tmpl = this.translations['materialRetiredInfo'];
    if (!tmpl) {
      return `<div class="material-retired-info-pane"><p><strong>This material has been retired.</strong></p><p>You can keep using it until <strong>${until}</strong>. Be sure to download your workbooks and worksheets for this material before this date to save your progress.</p></div>`;
    }
    return tmpl.replace(/\{\{accessUntil\}\}/g, until);
  }

  getCourseDetails(courseid: string) {
    this.courseservice.getCourseDetailsForParticipant(courseid).subscribe({
      next:(response) => {
        this.course = response;
        this.coursematerial = response.materialList;
        this.openThumbnailImage(this.course.courseThumbnailIconId);
        this.courseTags = this.course.tags.split(',');
        this.course.enrollmentStatus = response.participantCourseStatus;
        this.course.retired = response.retired;
        this.course.favoriteFlag = response.isFavourite;
        this.isViewCourseVisible = response.participantCourseStatus == "Completed";

        const preferNonRetired = this.course.materialList.find((item: { type: string; isMaterialRetired?: boolean }) =>
          item.type === 'E-book' && !item.isMaterialRetired);
        const anyEbook = this.course.materialList.find((item: { type: string; }) => item.type === 'E-book');
        const defaultMat = preferNonRetired ?? anyEbook;
        this.defaultMaterialId = defaultMat?.id ?? '';
      }
    });
  }

  openThumbnailImage(id: any) {
    this.fileservice.downloadFile(id).subscribe({
      next:(response) => {
        this.imageURL = response.url;
      }
    })
  }

  startCourse()
  {
    this.courseservice.participantStartCourse(this.id).subscribe({
      next:(response) => {
        if(response) {
          this.router.navigate(['/participants/courses/open-course/' + this.id + "/" + this.defaultMaterialId])
        }
      }
    });
  }

  resumeCourse() {
    this.router.navigate(['/participants/courses/open-course/' + this.id + "/" + this.defaultMaterialId])
  }

  handleFavouriteClick() {
    this.getCourseDetails(this.id);
  }

  public createPlan() {
    this.router.navigate(['/participants/plans/add-plan/']);
  }

  getCourseRetiredDetail(): string {
    const template = this.translations['courseRetiredDetailText']
      || 'This course has been retired. You can keep using it until {{accessUntil}}. Be sure to download your workbooks and worksheets in this course before this date to save your progress. If a new version of this course is available, you can start it anytime.';
    const until = this.course.courseRetirementAccessUntil || '';
    return template.replace(/\{\{accessUntil\}\}/g, until);
  }
}

